<template lang="pug">
  f7-button(
    class="button-pagenation"
    @click="$emit('click', $event)")
    svg-icon(:icon="iconName" class="icon-pagenation" :style="{ 'width': width }")
</template>

<style lang="scss" scoped>
.button-pagenation {
  display: inline-block;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 12px;
  background: rgba($color: #fff, $alpha: 0.1);
  vertical-align: middle;
  border: none;
}

.button-pagenation.disabled {
  opacity: 0.2 !important;
}

.icon-pagenation {
  margin: 6px auto;
}
</style>

<script>
const pageLinkTypes = {
  front: { iconName: 'front', width: '12px' },
  previous: { iconName: 'previous', width: '8px' },
  next: { iconName: 'next', width: '8px' },
  last: { iconName: 'last', width: '12px' },
}
export default {
  props: {
    pageLink: {
      default: 'front',
      validator: function (value) {
        return Object.keys(pageLinkTypes).indexOf(value) !== -1
      },
    },
  },
  computed: {
    iconName() {
      return pageLinkTypes[this.pageLink].iconName
    },
    width() {
      return pageLinkTypes[this.pageLink].width
    },
  },
}
</script>
